import { Info } from 'lucide-react';
import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip.tsx';

interface Props {
  children: ReactNode;
}

export function InstalledMetersTooltip({ children }: Props) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} className='inline-flex items-center gap-1'>
            {children}
            <Info className='h-3.5 w-3.5 text-muted-foreground' aria-hidden='true' />
          </span>
        </TooltipTrigger>
        <TooltipContent side='top' className='max-w-xs text-sm'>
          Installed meters are sensors in a Profile sensor group (i.e., under billing management).
          Total includes all sensors associated to the customer.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
